<template>
  <div class="operation-center-card flex-col">
    <div class="center-name-wrapper flex-col">
      <span class="center-short-name">{{ center.name }}</span>
    </div>
    <span class="center-full-name">{{ center.fullName }}</span>
  </div>
</template>

<script setup>
defineProps({
  center: {
    type: Object,
    required: true,
  },
})
</script>

<style lang="less" scoped>
.operation-center-card {
  width: 240px;
  height: 200px;
  background: center / contain no-repeat url(https://static.idicc.cn/cdn/official/H5/dadaSea05.png);
  background-size: 100%;
  border-radius: 16px;
  padding: 32px 10px 23px 10px;

  .center-name-wrapper {
    background: linear-gradient(180deg, #6BF3FF 0%, #1741CD 100%);
    border-radius: 40px;
    align-self: center;
    width: 80px;
    padding: 21px 12px 19px 12px;

    .center-short-name {
      color: rgba(255, 255, 255, 1);
      font-size: 28px;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-weight: normal;
      text-align: center;
      white-space: nowrap;
      line-height: 40px;
    }
  }

  .center-full-name {
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    line-height: 33px;
    margin-top: 20px;
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}
</style>
